<template>
  <el-dialog
    v-model="visible"
    :title="title"
    width="600px"
    append-to-body
    :before-close="close"
  >
    <el-form
      :model="editForm"
      ref="editFormRef"
      label-width="80px"
      :rules="rules"
    >
      <el-form-item label="登录图标" prop="loginIcon">
        <el-popover
          placement="bottom-start"
          :width="540"
          v-model:visible="showChooseIcon"
          trigger="click"
          @show="showSelectIcon"
        >
          <template #reference>
            <el-input
              v-model="editForm.loginIcon"
              placeholder="点击选择图标"
              @click="showSelectIcon"
              readonly
            >
              <template #prefix>
                <svg-icon
                  v-if="editForm.loginIcon"
                  :icon-name="editForm.loginIcon"
                  class="el-input__icon"
                  style="height: 32px; width: 16px"
                />
                <el-icon v-else style="height: 32px; width: 16px"
                  ><search
                /></el-icon>
              </template>
            </el-input>
          </template>
          <icon-select ref="iconSelectRef" @selected="selected" />
        </el-popover>
      </el-form-item>
      <el-form-item label="登录来源" prop="source">
        <el-input v-model="editForm.source" placeholder="请输入登录来源" />
      </el-form-item>
      <el-form-item label="登录 id" prop="clientId">
        <el-input v-model="editForm.clientId" placeholder="请输入登录 id" />
      </el-form-item>
      <el-form-item label="登录密钥" prop="clientSecret">
        <el-input
          v-model="editForm.clientSecret"
          placeholder="请输入登录密钥"
        />
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number
          v-model="editForm.sort"
          controls-position="right"
          :min="0"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="editForm.status">
          <dictionary-radio code="commonStatus" />
        </el-radio-group>
      </el-form-item>
    </el-form>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="handleSave" :loading="editLoading"
          >确 定</el-button
        >
      </div>
    </template>
  </el-dialog>
</template>
<script setup>
import { getCurrentInstance, ref } from 'vue'

import IconSelect from '@/components/IconSelect'

import { getById, add, update, getMaxSort } from '@/api/system/third/login'

const { proxy } = getCurrentInstance()

const visible = ref(false)
const title = ref('')
const editLoading = ref(false)
const rules = ref({
  loginIcon: [{ required: true, message: '登录不能为空', trigger: 'blur' }],
  source: [{ required: true, message: '登录来源不能为空', trigger: 'blur' }],
  clientId: [{ required: true, message: '登录 id 不能为空', trigger: 'blur' }],
  clientSecret: [
    { required: true, message: '登录密钥不能为空', trigger: 'blur' }
  ],
  sort: [{ required: true, message: '顺序不能为空', trigger: 'blur' }],
  status: [{ required: true, message: '请选择状态', trigger: 'blur' }]
})
const editForm = ref({
  id: undefined,
  loginIcon: undefined,
  source: undefined,
  clientId: undefined,
  clientSecret: undefined,
  status: '1',
  sort: undefined
})
const showChooseIcon = ref(false)
const iconSelectRef = ref(null)

/**
 * 显示弹窗
 */
async function show(id) {
  visible.value = true
  if (id) {
    title.value = '修改登录配置'
    // 获取角色信息
    const { data } = await getById(id)
    editForm.value = data
    editForm.value.status = editForm.value.status + ''
  } else {
    title.value = '新增登录配置'
    editForm.value.id = undefined
    const { data } = await getMaxSort()
    editForm.value.sort = data ? data + 1 : 1
  }
}

/**
 * 关闭
 */
function close() {
  visible.value = false
  showChooseIcon.value = false
  reset()
}

/**
 * 重置
 */
function reset() {
  proxy.resetForm('editFormRef')
}

/**
 * 展示下拉图标
 */
function showSelectIcon() {
  iconSelectRef.value.reset()
  showChooseIcon.value = true
}
/**
 * 选择图标
 */
function selected(name) {
  editForm.value.loginIcon = name
  showChooseIcon.value = false
}

/**
 * 提交数据
 */
const emit = defineEmits(null)
function handleSave() {
  proxy.$refs.editFormRef.validate(async (valid) => {
    if (valid) {
      editLoading.value = true
      try {
        // 修改
        if (editForm.value.id) {
          await update(editForm.value)
          proxy.$modal.msgSuccess('修改登录配置成功')
        } else {
          // 新增
          await add(editForm.value)
          proxy.$modal.msgSuccess('新增登录配置成功')
        }
        emit('fetch-data')
        close()
      } finally {
        editLoading.value = false
      }
    }
  })
}

defineExpose({
  show
})
</script>
